/**
 * Backend response from gql is a string value
 * The FE wants to use string constants for easier checks and handling
 *
 */ const mapPaymentState = (tokenResponse)=>{
    switch(tokenResponse === null || tokenResponse === void 0 ? void 0 : tokenResponse.state.key){
        case 'order-payment-authorized':
        case 'order-paid':
        case 'order-submitted':
            return 'Paid';
        case 'order-cancelled':
            return 'Failed';
        default:
            return undefined;
    }
};

export { mapPaymentState };
//# sourceMappingURL=payment-state.js.map
